import { render, staticRenderFns } from "./appdown.vue?vue&type=template&id=3506aadf&"
import script from "./appdown.vue?vue&type=script&lang=js&"
export * from "./appdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports